import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import MarketOverview from "components/Market/MarketOverview";

import * as marketReducer from "containers/Market/MarketReducer";

class MarketOverviewContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <MarketOverview {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateHireJob: (jobId, isHire) => dispatch(marketReducer.updateHireJob(jobId, isHire)),

    updateIsCreateJob: (isCreateJob) => dispatch(marketReducer.updateIsCreateJob(isCreateJob)),
    updateIsCreateConsultant: (isCreateConsultant) =>
      dispatch(marketReducer.updateIsCreateConsultant(isCreateConsultant))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    consultants: marketReducer.getConsultantsArr(state),
    jobs: marketReducer.getJobsArr(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketOverviewContainer);
